import React, { useState, useEffect } from 'react';

const HeroSection = () => {
  const galleryImages = [
    '/img/hero/h1.png',
    '/img/hero/h2.png',
    '/img/hero/h3.png',
    '/img/hero/h4.png',
  ];

  const [currentImage, setCurrentImage] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % galleryImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [galleryImages.length]);

  const scrollToPortfolio = () => {
    const portfolioSection = document.getElementById('portfolio');
    if (portfolioSection) {
      portfolioSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const scrollToContact = () => {
    const contactSection = document.getElementById('contact');
    if (contactSection) {
      contactSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-screen bg-gray-900">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src={galleryImages[currentImage]} 
          alt="Hero Background"
          className="w-full h-full object-cover transition-opacity duration-500"
        />
        <div className="absolute inset-0 bg-black/60"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 min-h-screen flex items-center">
        <div className="w-full py-20">
          {/* Badge */}
          <div className="mb-6">
            <span className="inline-flex items-center gap-2 bg-[#215f9a]/20 backdrop-blur-sm px-4 py-1.5 rounded-full">
              <span className="w-1.5 h-1.5 bg-[#215f9a] rounded-full animate-pulse"></span>
              <span className="text-white text-sm">2009 — CAMBODIA</span>
            </span>
          </div>

          {/* Title */}
          <div className="mb-4">
            <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white">
              Maosente
            </h1>
            <p className="text-xl md:text-2xl text-white/70 mt-2">
              (CAMBODIA) CO.,LTD.
            </p>
          </div>

          {/* Divider */}
          <div className="w-16 h-0.5 bg-[#215f9a] mb-6"></div>

          {/* Description */}
          <p className="text-white/80 text-lg max-w-2xl mb-8 leading-relaxed">
            Building tomorrow's infrastructure with excellence, innovation, and unwavering commitment to quality across Cambodia and beyond.
          </p>

          {/* Location */}
          <div className="flex items-start gap-3 mb-8">
            <svg className="w-5 h-5 text-[#215f9a] mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M17.657 16.657L13.414 20.9a1.998 1.998 0 01-2.827 0l-4.244-4.243a8 8 0 1111.314 0z" />
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M15 11a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
            <div>
              <p className="text-white/50 text-xs uppercase tracking-wider">HEADQUARTERS</p>
              <p className="text-white text-sm">
                HI-PARK Special Economic Zone
              </p>
            </div>
          </div>

          {/* Buttons */}
          <div className="flex flex-wrap gap-4 mb-8">
            <button 
              onClick={scrollToContact}
              className="px-6 py-3 bg-[#215f9a] text-white font-semibold rounded-md hover:bg-[#1a4d7a] transition-colors shadow-sm"
            >
              Contact Us
            </button>
            <button 
              onClick={scrollToPortfolio}
              className="px-6 py-3 border border-white/30 text-white font-semibold rounded-md hover:bg-white hover:text-black transition-colors"
            >
              Explore Portfolio
            </button>
          </div>

          {/* Stats */}
          <div className="flex gap-8">
            {[
              { value: '500+', label: 'Projects' },
              { value: '50+', label: 'Partners' },
              { value: '100%', label: 'Commitment' }
            ].map((stat, idx) => (
              <div key={idx}>
                <div className="text-2xl font-bold text-white">{stat.value}</div>
                <div className="text-xs text-white/50 uppercase tracking-wide">{stat.label}</div>
              </div>
            ))}
          </div>

          {/* Thumbnails */}
          <div className="mt-12">
            <div className="flex gap-3 overflow-x-auto pb-2 custom-scrollbar">
              {galleryImages.map((img, idx) => (
                <button
                  key={idx}
                  onClick={() => setCurrentImage(idx)}
                  className={`flex-shrink-0 transition-all duration-200 ${
                    currentImage === idx ? 'ring-2 ring-[#215f9a] scale-105' : 'opacity-60 hover:opacity-100'
                  }`}
                >
                  <img 
                    src={img} 
                    alt={`Thumb ${idx + 1}`}
                    className="w-20 h-20 object-cover rounded-md"
                  />
                </button>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button 
        onClick={() => window.scrollTo({ top: window.innerHeight, behavior: 'smooth' })}
        className="absolute bottom-6 left-1/2 -translate-x-1/2 hidden md:block group focus:outline-none"
      >
        <div className="text-center">
          <p className="text-white/40 text-xs uppercase tracking-wider mb-1 group-hover:text-white/60 transition-colors">
            Scroll
          </p>
          <div className="w-px h-12 bg-[#215f9a] mx-auto group-hover:h-14 transition-all duration-300"></div>
        </div>
      </button>

      {/* Add custom scrollbar styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          height: 4px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: rgba(255, 255, 255, 0.1);
          border-radius: 2px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #215f9a;
          border-radius: 2px;
        }
      `}</style>
    </section>
  );
};

export default HeroSection;